var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandmarkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5V3.875L6 0.5L12 3.875V5H10.875H1.125H0ZM6 1.8125L2.27344 3.875H9.70312L6 1.8125ZM2.625 5.75V9.5H4.125V5.75H5.25V9.5H6.75V5.75H7.875V9.5H9.375V5.75H10.5V9.5H10.6875H11.25V10.625H10.6875H1.3125H0.75V9.5H1.3125H1.5V5.75H2.625ZM0 11.375H0.5625H11.4375H12V12.5H11.4375H0.5625H0V11.375Z",
    fill: "#9DD2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandmarkBlue);
export default __webpack_public_path__ + "static/media/landmark-blue.0025a8513784c01697d08cb7a0badc4e.svg";
export { ForwardRef as ReactComponent };